
function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return import.meta.resolve($parcel$distDir + url);
}

      var $parcel$global = globalThis;
    var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire305d"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire305d"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
var $e18fbb2d9860ccc2$exports = {};
$parcel$extendImportMap({
    "lWjQz": "gallery-1.04ff0051.jpg",
    "hlITq": "gallery-2.029047c7.jpg",
    "5p2Ap": "gallery-3.c311d733.jpg",
    "2nPVE": "gallery-4.5bb1de37.jpg",
    "koXzd": "gallery-5.bc80667c.jpg",
    "3htJv": "gallery-6.a530c74f.jpg",
    "1ZiZc": "gallery-7.369fc5df.jpg",
    "gHlJh": "gallery-8.78b42ef6.jpg",
    "jdzJM": "gallery-9.9f9c9c20.jpg",
    "fUckL": "gallery-10.c03af9a8.jpg",
    "dkaF0": "gallery-11.8b59680a.jpg",
    "jKHib": "gallery-12.f982185b.jpg"
});

// const images = require('./images/*.jpg');
var $246b3c4c7142557b$exports = {};
$246b3c4c7142557b$exports = $parcel$resolve("lWjQz");


const $54b47fc030b7b21e$var$gallery1 = new URL($246b3c4c7142557b$exports).href;
var $61f22cf6ae879ea9$exports = {};
$61f22cf6ae879ea9$exports = $parcel$resolve("hlITq");


const $54b47fc030b7b21e$var$gallery2 = new URL($61f22cf6ae879ea9$exports).href;
var $1c969c2685a117d9$exports = {};
$1c969c2685a117d9$exports = $parcel$resolve("5p2Ap");


const $54b47fc030b7b21e$var$gallery3 = new URL($1c969c2685a117d9$exports).href;
var $2436b9012b227213$exports = {};
$2436b9012b227213$exports = $parcel$resolve("2nPVE");


const $54b47fc030b7b21e$var$gallery4 = new URL($2436b9012b227213$exports).href;
var $95826d2ffbb36533$exports = {};
$95826d2ffbb36533$exports = $parcel$resolve("koXzd");


const $54b47fc030b7b21e$var$gallery5 = new URL($95826d2ffbb36533$exports).href;
var $cf4dea09dc2ede8f$exports = {};
$cf4dea09dc2ede8f$exports = $parcel$resolve("3htJv");


const $54b47fc030b7b21e$var$gallery6 = new URL($cf4dea09dc2ede8f$exports).href;
var $40cb092690440fd7$exports = {};
$40cb092690440fd7$exports = $parcel$resolve("1ZiZc");


const $54b47fc030b7b21e$var$gallery7 = new URL($40cb092690440fd7$exports).href;
var $d740844a31edc9fe$exports = {};
$d740844a31edc9fe$exports = $parcel$resolve("gHlJh");


const $54b47fc030b7b21e$var$gallery8 = new URL($d740844a31edc9fe$exports).href;
var $1e7c8a657400d64a$exports = {};
$1e7c8a657400d64a$exports = $parcel$resolve("jdzJM");


const $54b47fc030b7b21e$var$gallery9 = new URL($1e7c8a657400d64a$exports).href;
var $c442812cf2527390$exports = {};
$c442812cf2527390$exports = $parcel$resolve("fUckL");


const $54b47fc030b7b21e$var$gallery10 = new URL($c442812cf2527390$exports).href;
var $ba8fffac45198f04$exports = {};
$ba8fffac45198f04$exports = $parcel$resolve("dkaF0");


const $54b47fc030b7b21e$var$gallery11 = new URL($ba8fffac45198f04$exports).href;
var $9cdb5ccce8736e60$exports = {};
$9cdb5ccce8736e60$exports = $parcel$resolve("jKHib");


const $54b47fc030b7b21e$var$gallery12 = new URL($9cdb5ccce8736e60$exports).href;
// Battery
function $54b47fc030b7b21e$var$toggleSlideoverBattery() {
    document.getElementById('slideover-battery-container').classList.toggle('invisible');
    document.getElementById('slideover-battery-bg').classList.toggle('opacity-0');
    document.getElementById('slideover-battery-bg').classList.toggle('opacity-50');
    document.getElementById('slideover-battery').classList.toggle('translate-y-full');
    var element = document.getElementById("body");
    element.classList.toggle('noscroll');
}
document.addEventListener('DOMContentLoaded', function() {
    var toggleButton = document.querySelector('#batteryButton1');
    if (toggleButton) toggleButton.addEventListener('click', $54b47fc030b7b21e$var$toggleSlideoverBattery);
});
document.addEventListener('DOMContentLoaded', function() {
    var toggleButton = document.querySelector('#batteryButton2');
    if (toggleButton) toggleButton.addEventListener('click', $54b47fc030b7b21e$var$toggleSlideoverBattery);
});
document.addEventListener('DOMContentLoaded', function() {
    var toggleButton = document.querySelector('#batteryButton3');
    if (toggleButton) toggleButton.addEventListener('click', $54b47fc030b7b21e$var$toggleSlideoverBattery);
});
document.addEventListener('DOMContentLoaded', function() {
    var toggleButton = document.querySelector('#slideover-battery-bg');
    if (toggleButton) toggleButton.addEventListener('click', $54b47fc030b7b21e$var$toggleSlideoverBattery);
});
document.addEventListener('DOMContentLoaded', function() {
    var toggleButton = document.querySelector('#slideover-battery');
    if (toggleButton) toggleButton.addEventListener('click', $54b47fc030b7b21e$var$toggleSlideoverBattery);
});
// Gallery
function $54b47fc030b7b21e$var$toggleSlideoverGallery(e) {
    document.getElementById('slideover-gallery-container').classList.toggle('invisible');
    document.getElementById('slideover-gallery-bg').classList.toggle('opacity-0');
    document.getElementById('slideover-gallery-bg').classList.toggle('opacity-50');
    document.getElementById('slideover-gallery').classList.toggle('translate-y-full');
    var element = document.getElementById("body");
    element.classList.add('noscroll');
    var imageUrl = e.currentTarget.myParam;
    var altText = 'Description of the image';
    var imageElement = $54b47fc030b7b21e$var$createImage(imageUrl, altText);
    var content = document.getElementById('gallery-content');
    content.innerHTML = "";
    content.appendChild(imageElement);
}
function $54b47fc030b7b21e$var$closeSlideoverGallery(e) {
    document.getElementById('slideover-gallery-container').classList.toggle('invisible');
    document.getElementById('slideover-gallery-bg').classList.toggle('opacity-0');
    document.getElementById('slideover-gallery-bg').classList.toggle('opacity-50');
    document.getElementById('slideover-gallery').classList.toggle('translate-y-full');
    var element = document.getElementById("body");
    element.classList.remove('noscroll');
// var content = document.getElementById('gallery-content');
// content.innerHTML = "";
}
function $54b47fc030b7b21e$var$createImage(src, altText) {
    var img = document.createElement('img'); // Create a new img element
    img.classList.add('gallery-lightbox-image');
    img.alt = altText; // Set the alt attribute of the img element
    img.addEventListener('load', function() {
        requestAnimationFrame(function() {
            img.classList.add('is-loaded');
        });
    }, {
        once: true
    });
    img.src = src; // Set the src attribute of the img element
    return img; // Return the created img element
}
document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('[data-lightbox]').forEach(function(button) {
        button.addEventListener('click', function(e) {
            var image = e.currentTarget.querySelector('img');
            e.currentTarget.myParam = image.currentSrc || image.src;
            $54b47fc030b7b21e$var$toggleSlideoverGallery(e);
        });
    });
});
document.addEventListener('DOMContentLoaded', function() {
    var galleryImages = [
        $54b47fc030b7b21e$var$gallery1,
        $54b47fc030b7b21e$var$gallery2,
        $54b47fc030b7b21e$var$gallery3,
        $54b47fc030b7b21e$var$gallery4,
        $54b47fc030b7b21e$var$gallery5,
        $54b47fc030b7b21e$var$gallery6,
        $54b47fc030b7b21e$var$gallery7,
        $54b47fc030b7b21e$var$gallery8,
        $54b47fc030b7b21e$var$gallery9,
        $54b47fc030b7b21e$var$gallery10,
        $54b47fc030b7b21e$var$gallery11,
        $54b47fc030b7b21e$var$gallery12
    ];
    galleryImages.forEach(function(imageUrl, index) {
        var galleryImage = document.querySelector('#gallery-image-' + (index + 1));
        if (!galleryImage) return;
        galleryImage.myParam = imageUrl;
        galleryImage.addEventListener('click', $54b47fc030b7b21e$var$toggleSlideoverGallery, false);
    });
});
document.addEventListener('DOMContentLoaded', function() {
    var toggleButton = document.querySelector('#slideover-gallery-bg');
    if (toggleButton) toggleButton.addEventListener('click', $54b47fc030b7b21e$var$closeSlideoverGallery);
});
document.addEventListener('DOMContentLoaded', function() {
    var toggleButton = document.querySelector('#slideover-gallery');
    if (toggleButton) toggleButton.addEventListener('click', $54b47fc030b7b21e$var$closeSlideoverGallery);
});
// Scroll reveal
document.addEventListener('DOMContentLoaded', function() {
    var elements = document.querySelectorAll('[data-reveal]');
    if (!elements.length) return;
    document.documentElement.classList.add('reveal-ready');
    if (!('IntersectionObserver' in window)) {
        elements.forEach(function(element) {
            element.classList.add('is-visible');
        });
        return;
    }
    var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
        });
    }, {
        threshold: 0.15
    });
    elements.forEach(function(element) {
        observer.observe(element);
    });
});


//# sourceMappingURL=inklay_2_hosting.94908e39.js.map
